import { useState, useEffect } from 'react';

/**
 * Hook para manejar el localStorage.
 * @param {string} key - La clave del localStorage.
 * @param {any} initialValue - Valor inicial si no existe el valor en localStorage.
 * @returns {Array} - Un array con el valor y una función para actualizarlo.
 */
const useLocalStorage = (key, initialValue) => {
    // Estado para el valor
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Intenta obtener el valor del localStorage
            const item = window.localStorage.getItem(key);
            // Si existe, parsea y devuelve
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error(error);
            return initialValue;
        }
    });

    // Efecto para sincronizar el valor con localStorage
    useEffect(() => {
        try {
            // Almacena el valor en localStorage
            window.localStorage.setItem(key, JSON.stringify(storedValue));
        } catch (error) {
            console.error(error);
        }
    }, [key, storedValue]);

    return [storedValue, setStoredValue];
};

export default useLocalStorage;
